__turbopack_context__.v({
  "icon": "SelectQuestion-module-scss-module__oQKpSq__icon",
});
